import { ComponentProps } from 'react';
import Card from 'antd/es/card';
import clsx from 'clsx';

const { Meta } = Card;

export interface OpCardProps extends ComponentProps<typeof Card> {
  testId?: string;
}

/**
 * OpCard is a wrapper around Ant Design's Card component.
 * It provides a container for grouping related content with optional headers, borders, and actions.
 * 
 * Use this component to organize and display content in a structured, card-based layout.
 * Supports OpCard.Meta for additional card metadata display.
 * 
 * @example
 * <OpCard title="Card Title" extra={<a href="#">More</a>}>
 *   Card content
 * </OpCard>
 * 
 */
export const OpCard = ({
  className,
  testId = 'op-card',
  ...cardProps
}: OpCardProps) => {
  return (
    <Card
      className={clsx('op-card', className)}
      data-testid={testId}
      {...cardProps}
    />
  );
};

OpCard.Meta = Meta;
